export default "https://cdn-static.gokick.com/assets/c678e0ba2e275fccd6b7b161f66793b4454cd3c4/images/sleep-blueberry.3ee2bf0b929baac3dd5c59083edb83bb.png";